import React from 'react';
import { BreadCrumb } from '../components/breadcrumbs/BreadCrumb';
import { BreadRoute } from '../components/breadcrumbs/BreadRoute';
import { Card } from '../components/utils/Card';


export const CertMenu: React.FC = () => {


    return (
        <div className='container w-screen h-screen'>
            <BreadRoute>
                <BreadCrumb
                    label={'cert-menu'}
                    link={'/certmenu'}
                    lastChild={true} />
            </BreadRoute>
            <div className='container h-full max-h-11/12 w-full flex justify-center'>
                <Card
                    header='Cert.Card.Create.Header'
                    paragraph={'Cert.Card.Create'}
                    link={`/createcert`}
                    linkStr={'Navigation.Cert_New'}
                    image='img/grad-cap.png'
                    canClick={true} />
                <Card
                    header='Cert.Card.Certs.Header'
                    paragraph={'Cert.Card.Certs'}
                    link={`/certs`}
                    linkStr={'Navigation.Cert_All'}
                    image='img/letter_alt.png'
                    canClick={true} />
            </div>
        </div>
    );
}

export default CertMenu;